import * as Scrivito from "scrivito";
import boxWidgetIcon from "../../assets/images/box_widget.svg";

Scrivito.provideEditingConfig("BoxWidget", {
  title: "Box",
  thumbnail: boxWidgetIcon,
  properties: ["boxStyle"],
  initialContent: {
    boxStyle: "transparent",
    useOffset: "no",
  },
});
